import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

interface IErrorSnackbarProps {
  error: boolean;
  onClose: () => void;
}

export default function ErrorSnackbar(props: IErrorSnackbarProps) {
  const { error, onClose } = props;

  return (
    <Snackbar
      open={error}
      autoHideDuration={50000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      disableWindowBlurListener
      onClose={onClose}
    >
      <Alert
        severity="error"
        onClose={onClose}
      >
        An error occurred while submitting your feedback.<br /> Please try again.
      </Alert>
    </Snackbar>
  );
}
